import React, { useMemo } from 'react';
import { Carousel } from 'react-bootstrap';
import '../styles/FeaturedSlider.scss';
import '../styles/Carousel.scss';
import pioneer from '../images/pioneer.png';
import blackFriday from '../images/black-friday.png';
import cyberMonday from '../images/cyber-monday.png';
import generalConferenceSale from '../images/general-conference-sale.png';
import feature1 from '../images/feature1.png';
import feature2 from '../images/feature2.png';
import feature3 from '../images/feature3.png';
import feature4 from '../images/feature4.png';
import feature5 from '../images/feature5.png';
import feature6 from '../images/feature6.png';
import feature7 from '../images/feature7.png';
import feature8 from '../images/feature8.png';
import feature9 from '../images/feature9.png';
import feature10 from '../images/feature10.png';
import { useCustomContext } from './ContextHook';

function getIcon(iconName: string): string {
    let icon;
    switch (iconName) {
        case 'black-friday':
            icon = blackFriday
            break;
        case 'pioneer':
            icon = pioneer
            break;
        case 'general-conference-sale':
            icon = generalConferenceSale
            break
        case 'cyber-monday':
            icon = cyberMonday
            break
        default:
            throw new Error('Missing icon in configs')
    }
    return icon
}

interface Feature {
    icon: string;
    title: string;
    description: string;
    style?: object
}


const features: Feature[] = [
    {
        icon: feature1,
        title: 'See Who Likes You',
        description: 'View people who have already swiped up on you!'
    },
    {
        icon: feature2,
        title: '8 Gold Notes Weekly',
        description: "People sending Gold Notes get twice as many matches as those that don't send them"
    },
    {
        icon: feature3,
        title: 'Unlimited Speed Dating',
        description: 'Join every speed dating session for as long as you want!'
    },
    {
        icon: feature4,
        title: 'Travel with Ward Hop',
        description: 'Search from anywhere around the world!'
    },
    {
        icon: feature5,
        title: 'Advanced Filters',
        description: 'Filter your swiping results and only see those you are interested in!'
    },
    {
        icon: feature6,
        title: 'Unlimited Likes',
        description: 'Swipe up on as many profiles as you want each day.'
    },
    {
        icon: feature7,
        title: 'Ninja Mode',
        description: 'Hide your profile from everyone except for those you swipe up on.'
    },
    {
        icon: feature8,
        title: 'Read Receipts in Chat',
        description: 'See if your matches have read your last message in chat.'
    },
    {
        icon: feature9,
        title: 'Unlimited Undos',
        description: 'Everyone makes mistakes. Undo your swipes and bring them back.'
    },
    {
        icon: feature10,
        title: 'Prioritized Profile',
        description: 'Your profile is shown to others more often.'
    },
];

const FeaturedSlider = () => {
    const { configs } = useCustomContext()
    const currentEvent = configs?.currentEvent;
    
    const displayFeatures = useMemo(() => {
        if (currentEvent && currentEvent.name) {
            const eventName = currentEvent.name;
            const eventFeature: Feature = {
                icon: getIcon(eventName),
                title: currentEvent?.theme?.title || 'Limited Time Sale',
                description: currentEvent?.theme?.subtitle || 'Save up to 70% on premium!',
                style: eventName === 'general-conference-sale' ? { objectFit: 'contain', width: '100%' } : { width: '90%' }
            };
            return [eventFeature, ...features];
        }
        return features;
    }, [currentEvent]);
    
    return (
        <Carousel>
            {displayFeatures.map((feature: Feature, index: number) => (
                <Carousel.Item key={index} interval={3000}>
                    <div className="slide">
                        <div className="icon">
                            <img src={feature.icon} alt={feature.title} style={feature?.style} />
                        </div>
                        <p className='feature-title'>{feature.title}</p>
                        <p className='feature-description'>{feature.description}</p>
                    </div>
                </Carousel.Item>
            ))}
        </Carousel>
    );
}

export default FeaturedSlider;